export const CLONED_ROUTINE_PREFIX = '[cloned]';

export function normalizeClonedRoutineName(rawName) {
  const trimmed = String(rawName || '').trim();
  const prefixWithSpace = `${CLONED_ROUTINE_PREFIX} `;
  const lower = trimmed.toLowerCase();
  const prefixLower = prefixWithSpace.toLowerCase();

  if (lower.startsWith(prefixLower)) {
    const rest = trimmed.slice(prefixWithSpace.length).trim();
    return rest ? `${prefixWithSpace}${rest}` : `${prefixWithSpace}Routine`;
  }
  if (lower === CLONED_ROUTINE_PREFIX.toLowerCase()) {
    return `${prefixWithSpace}Routine`;
  }
  return trimmed ? `${prefixWithSpace}${trimmed}` : `${prefixWithSpace}Routine`;
}

export function clonedRoutineSuffixFromName(sourceName) {
  const trimmed = String(sourceName || '').trim();
  const prefixWithSpace = `${CLONED_ROUTINE_PREFIX} `;
  const lower = trimmed.toLowerCase();
  const prefixLower = prefixWithSpace.toLowerCase();
  if (lower.startsWith(prefixLower)) {
    return trimmed.slice(prefixWithSpace.length).trim();
  }
  return trimmed;
}
